module.exports = __webpack_public_path__ + "assets/b28.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b28.png
// module id = 614
// module chunks = 0